<template>
  <div id="app" class="w-app" :class="{ embed: isEmbed }">
    <div v-if="!isEmbed" id="menu" class="z1 flex justify-between fixed">
      <div v-if="this.$route.name !== 'User'" @click="menuVisible = true" class="pl2 col-3 left-align">
        <menu-icon/>
      </div>
      <div v-else class="pl2 col-3 left-align">
        <router-link to="/"><back-icon/></router-link>
      </div>
      <div class="col-6 center">
        <span @click="refresh" class="pointer" v-if="this.$route.name === 'Home'" to="/">Field Notes</span>
        <router-link v-else-if="this.$route.name !== 'User'" to="/">Field Notes</router-link>
        <span v-else>@{{ this.$route.params.username }} </span>
      </div>
      <div class="pr2 col-3 right-align">
        <span v-if="canRefresh" @click="refresh" class="pointer">
          <refresh-icon class="tt" v-bind:class="{ rotating: refreshBusy }" />
        </span>
        <span @click="toggleAdd" class="pointer ml2">
          <plus-icon :class="{ menurotate: addMenuVisible }" class="tt"/>
        </span>
        <!-- <span @click="selectFile" class="pointer">Add</span>
        <input @change="fileUpdated" ref="fileSelector" type="file" accept="image/* video/* audio/*;capture=camera" hidden> -->
      </div>

      <!-- 'add new' menu -->
      <transition name="fade">
        <div v-if="addMenuVisible" @click="toggleAdd" class="bg-white absolute right-0 left-0 top-0 p2 center z1 mt-header">
          <div class="py1">
            <a @click="add('note')" class="pointer">Text Note</a>
          </div>
          <div class="py1 desktop-hide">
            <a @click="add('media')" class="pointer">Photo or Video</a>
          </div>
          <div class="py1 desktop-hide">
            <a @click="add('sound')" class="pointer">Record a Sound</a>
          </div>
          <div class="py1 mobile-hide">
            <a @click="add('media')" class="pointer">Select a File</a>
          </div>
        </div>
      </transition>
    </div>

    <transition name="custom-classes-transition" enter-active-class="animated slideInRight" leave-active-class="animated slideOutRight">
      <add-new v-if="addModalVisible" :type="addModalVisible" @close="close"/>
    </transition>

    <transition name="custom-classes-transition" enter-active-class="animated slideInLeft" leave-active-class="animated slideOutLeft">
      <side-menu v-if="menuVisible" @close="menuVisible = false"/>
    </transition>

    <!-- taxonomies overlay -->
    <transition name="custom-classes-transition" enter-active-class="animated slideInRight" leave-active-class="animated slideOutRight">
      <view-tags v-if="viewingTags" :tag="viewingTags" @close="viewingTags = false"/>
    </transition>

    <transition-expand>
      <div v-if="bannerStatus.show" class="message-banner">
        <div>{{ bannerStatus.text }}</div>
      </div>
    </transition-expand>

    <router-view ref="foo"/>

    <div v-if="!isEmbed" id="footer" class="flex justify-between fixed px3 h6">
      <router-link to="/">Latest</router-link>
      <router-link to="/nearby">Nearby</router-link>
      <router-link to="/mine">Mine</router-link>
    </div>

    <modal-login/>

    <modal-add-to-homescreen/>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import globals from '@/globals'
  import AddNew from '@/components/AddNew'
  import SideMenu from '@/components/SideMenu'
  import ViewTags from '@/components/ViewTags'
  import TransitionExpand from '@/components/TransitionExpand'

  export default {
    name: 'App',
    data () {
      return {
        addMenuVisible: false,
        addModalVisible: false,
        menuVisible: false,
        refreshBusy: false,
      }
    },
    computed: {
      location: {
        get () {
          return this.$store.state.location
        },
        set (newVal) {
          this.$store.commit('UPDATE_LOCATION', newVal)
        }
      },
      queue () {
        return this.$store.state.uploadQueue
      },
      viewingTags: {
        get () {
          const { query } = this.$route
          return query.tagtype ? query : false
        },
        set () {
          this.$router.go(-1)
        }
      },
      canRefresh () {
        const views = ['Home', 'Nearby']
        return views.includes(this.$route.name)
      },
      ...mapState([ 'processingQueue', 'bannerStatus' ])
    },
    watch: {
      addModalVisible (newVal) {
        const el = document.scrollingElement.classList
        if (newVal) {
          el.add('overflow-hidden')
        } else {
          el.remove('overflow-hidden')
        }
      },
      queue (newVal) {
        if (newVal.length) {
          this.$store.dispatch('processQueue')
        }
      },
      $route () {
        this.addMenuVisible = false
        this.addModalVisible = false
      },
      menuVisible (newVal) {
        if (newVal) {
          this.addMenuVisible = false
        }
      },
      processingQueue (newVal, oldVal) {
        if (newVal && !oldVal) {
          this.$store.dispatch('setBanner', {
            message: 'Uploading...'
          })
        } else if (!newVal && oldVal) {
          this.$store.dispatch('setBanner', {
            message: 'Upload complete',
            duration: globals.banner.duration
          })
        }
      }
    },
    methods: {
      async refresh () {
        try {
          this.refreshBusy = true
          await this.$refs.foo.refresh()
          this.refreshBusy = false
          document.scrollingElement.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
          })
        } catch (err) {
          this.refreshBusy = false
          throw err
        }
      },
      isStandalone () {
        if (window.navigator.standalone) {
          return true
        } else {
          return false
        }
      },
      toggleAdd () {
        this.addMenuVisible = !this.addMenuVisible
      },
      add (type) {
        this.addModalVisible = type
      },
      close () {
        this.addModalVisible = false
      }
    },
    mounted () {
      if (!this.isEmbed) {
        this.$store.dispatch('startLocationPoll')
      }

      if (!this.isStandalone() && !this.$store.state.promptedToAddPwa) {
        setTimeout(() => {
          this.$store.dispatch('addToHomescreen')
        }, 2000)
      }
    },
    beforeMount () {
      Promise.all([
        this.$store.dispatch('truncateAllNotes', globals.pagination.perPage)
      ]).finally(() => {
        this.loading = false
      })
    },
    components: { AddNew, SideMenu, ViewTags, TransitionExpand }
  }
</script>

<style>
  @import 'css/app.css';

  #app:not(.embed) {
    padding-top: 3em;
  }

  #menu {
    background: white;
    top: 0;
    left: 0;
    right: 0;
    padding-top: 0.85rem;
    padding-bottom: 0.75rem;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
  }

  #footer {
    background: white;
    bottom: 0;
    left: 0;
    right: 0;
    padding-top: 1em;
    padding-bottom: 1em;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;

    a {
      text-transform: uppercase;
      border: 1px solid white;
      border-radius: 12px;
      padding: 0.3em 1em;

      &.router-link-exact-active {
        border-color: black;
      }
    }
  }

  .mt-header { margin-top: 3em; }

  .w-app {
    max-width: 600px;
    margin: 0 auto;
  }

  /* global wp modifications */

  figure.wp-block-image, figure.wp-block-audio, figure.wp-block-video {
    margin: 0;
  }

  figure.wp-block-image img, figure.wp-block-audio audio, figure.wp-block-video video {
    width: 100%;
  }

  .tt {
    transition: transform .16s;
    transform-origin: 50% 58%;
  }
  .menurotate { transform: rotate(135deg); }

  @keyframes rotating {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  .rotating {
    animation: rotating 0.7s linear infinite;
  }

  .message-banner {
    box-sizing: border-box;
    text-align: center;
    border: 1px solid black;
    margin-top: 3px;
  }

  .message-banner > div {
    padding: var(--space-2);
    font-size: 11px;
  }
</style>
